import {Controller} from "@hotwired/stimulus";

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["display"];
  static values = {
    expiresAt: String,
    redirectUrl: String,
    message: String,
  };

  connect() {
    this.expiresAt = new Date(this.expiresAtValue);
    this.startTimer();
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }

  }

  startTimer() {
    this.updateDisplay();
    this.timer = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    const now = new Date();
    const timeLeft = this.expiresAt - now;

    if (timeLeft <= 0) {
      clearInterval(this.timer);
      closeAllModals()
      if (this.hasMessageValue) {
        displayFlashMessage('info', this.messageValue)
      }
      return;
    }

    const minutes = Math.floor(timeLeft / 60000);
    const seconds = Math.floor((timeLeft % 60000) / 1000);

    this.displayTarget.textContent = `${minutes}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }
}
